export enum ExternalLinkTypeEnum {
    www = 'Www',
    Facebook = 'Facebook',
    Instagram = 'Instagram',
    Twitter = 'Twitter',
    YouTube = 'YouTube',
    Pinterest = 'Pinterest',
    TikTok = 'TikTok',
    Snapchat = 'Snapchat',
    LinkedIn = 'LinkedIn',
    GoodReads = 'GoodReads.com',
    LubimyCzytac = 'LubimyCzytac.pl',
    Wykop = 'Wykop.pl',
    Inne = 'Inne'
}
